import './theme.css';
import type { AgentLogo } from '@/app/lib/stage/StageHeader.tsx';
import { defineMessages, type MessageDescriptor } from 'react-intl';

const siteMessages = defineMessages({
  askPlaceholder: {
    id: 'composer.mapleMopPrompt',
    defaultMessage: 'Ask about a cleaning estimate...',
    description: 'Invitation shown inside the empty Maple & Mop composer.',
  },
});

export interface SiteConfig {
  brandName: string;
  /** Optional logo in a scrolling circle. Clicking sends Start over within this conversation. */
  logo?: AgentLogo;
  /** The assistant's appearance. 'auto' follows the visitor's OS setting. */
  appearance: 'light' | 'dark' | 'auto';
  /** Fixed visitor-facing language and formatting locale, ignoring browser defaults. */
  visitorLocale?: string;
  /** Omnibox placeholder override. */
  placeholder?: MessageDescriptor;
}

export const SITE_CONFIG: SiteConfig = {
  brandName: 'Maple & Mop Cleaning',
  appearance: 'light',
  visitorLocale: 'en-US',
  placeholder: siteMessages.askPlaceholder,
};
